import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.popup-content {
    border-radius: 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    padding: 0;
    color: #475359;
}
.close-btn {
    float: right;
    margin: calc(8px * 5) calc(8px * 3) 0 0;
    outline: 0;
    border: 0;
    background: none;
    padding: 0;
    font-family: inherit;
    font-style: inherit;
    cursor: pointer;
}
.close-btn-img {
    width: 24px;
    height: 24px;
}
a {
    color: #086ea1;
    text-decoration: underline;
}
a:hover {
    color: #004466;
}
/* Interstitial Modal */
.modal-lead-gen {
    padding: 0;
    font-family: 'Nimbus Sans', sans-serif;
    line-height: 22px;
    background-color: #f0f3f5;
}
.modal-main-content {
    padding: calc(8px * 4) calc(8px * 6)
        calc(8px * 4) calc(8px * 6);
    background: #ffffff;
}
.title {
    font-size: 32px;
    line-height: 38px;
    letter-spacing: -0.75px;
    color: #475359;
    font-family: 'Nimbus Sans Light', sans-serif;
    font-style: normal;
    padding-right: 8px;
    margin-bottom: 10px;
}
p {
    font-family: 'Nimbus Sans', sans-serif;
    font-size: 16px;
    line-height: 22px;
    color: #56646b;
    margin-bottom: calc(8px * 3);
    padding: 0;
}
label {
    font-family: 'Nimbus Sans Reg', sans-serif;
    font-size: 16px;
    line-height: 22px;
    color: #56646b;
    margin-bottom: 8px;
    padding: 0;
}
.placeholder {
    color: #475359;
    opacity: 0.4;
}
.required {
    color: #475359;
    opacity: 0.4;
}
.lead-input {
    border: 1px solid #898989;
    width: 100%;
    padding: 8px;
    border-radius: 3px;
    position: relative;
    margin: 8px 0 calc(8px * 4) 0;
}
button.text-button {
    text-align: center;
    vertical-align: top;
    font-size: 14px;
    color: #ffffff;
    background: #006894;
    padding: 14px;
    border-radius: 0;
    margin-top: calc(8px * 2);
    border: none;
    width: 100%;
}
.footer p {
    font-family: 'Nimbus Sans', sans-serif;
    font-size: 12px;
    line-height: 22px;
    padding: calc(8px * 2) calc(8px * 6)
        calc(8px * 4) calc(8px * 6);
    margin: 0;
}
.disabled {
    pointer-events: none;
    opacity: 0.4;
}
`;

export default styles;


// WEBPACK FOOTER //
// ./src/components/LeadGenForm/LeadGenForm.css